import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const styleButtonSocials = (theme) => ({
  gap: 1,
  fontWeight: 400,
  color: theme.vars.palette.common.black,
  backgroundColor: theme.vars.palette.common.white,
  borderColor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
  '&:hover': {
    backgroundColor: varAlpha(theme.vars.palette.grey['400Channel'], 0.8),
  },
});

export function FormSocials({ signInWithGoogle, singInWithGithub, signInWithX, sx, ...other }) {
  const { t } = useTranslate();

  return (
    <Box
      sx={[
        {
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {singInWithGithub && (
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={singInWithGithub}
          sx={[(theme) => styleButtonSocials(theme)]}
        >
          <Iconify icon="fa6-brands:github" width={18} sx={{ color: 'text.primary' }} />
          {t('Continue with')} Github
        </Button>
      )}

      {signInWithGoogle && (
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={signInWithGoogle}
          sx={[(theme) => styleButtonSocials(theme)]}
        >
          <Iconify icon="logos:google-icon" width={18} />
          {t('Continue with')} Google
        </Button>
      )}

      {signInWithX && (
        <Button
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          onClick={signInWithX}
          sx={[(theme) => styleButtonSocials(theme)]}
        >
          {t('Continue with')}
          <Iconify icon="fa6-brands:x-twitter" width={18} sx={{ color: 'common.dark' }} />
        </Button>
      )}
    </Box>
  );
}
